var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._b({attrs:{"hide-details":""},on:{"change":_vm.handleToggle},model:{value:(_vm.toggleValue),callback:function ($$v) {_vm.toggleValue=$$v},expression:"toggleValue"}},'v-switch',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }